import { Request } from '../main'
import Link from 'next/link'
import {Image} from 'react-bootstrap'

const request = new Request(process.env.apiDomain)

function StripContactMe(props) {
    const site = props.site
    const auth = props.auth
    const profile = props.profile
    const isShakleeDistributor = props.isShakleeDistributor
    
    // Fallback to original logic if props are not passed
    const { data: fallbackProfile } = request.account.swrAccountProfile(site.accountId)
    const actualProfile = profile || fallbackProfile
    
    const { data: shaklee } = request.account.swrShakleeInfo(site.accountId, actualProfile ? actualProfile.user.id : actualProfile)
    const { data: trialInfo } = request.account.swrTrialInfo(site.accountId, actualProfile ? actualProfile.user.id : actualProfile)

    // Enhanced Shaklee detection with multiple methods
    // Updated detectShaklee function in StripContactMe.js
    const detectShaklee = () => {
        console.log('=== SHAKLEE DETECTION START ===');
        console.log("shaklee on the mix: ", shaklee);

        // PRIORITY 1: Check trial info for company_name (MOST RELIABLE)
        if (trialInfo) {
            try {
                // Check if trialInfo is already an object or needs parsing
                let trialData;
                if (typeof trialInfo === 'string') {
                    trialData = JSON.parse(trialInfo);
                } else if (typeof trialInfo === 'object' && trialInfo !== null) {
                    trialData = trialInfo; // It's already an object
                }
                
                if (trialData?.company_name?.toLowerCase() === 'shaklee') {
                    console.log('✅ SHAKLEE CONFIRMED via trial info company_name:', trialData.company_name);
                    return true;
                } else if (trialData?.company_name?.toLowerCase() === 'melaleuca') {
                    console.log('❌ MELALEUCA detected via trial info - NOT Shaklee');
                    return false;
                }
            } catch (e) {
                console.log('❌ Trial data parsing error:', e);
            }
        }

        // PRIORITY 2: Check actual Shaklee API data (MOST RELIABLE)

        if (shaklee && (shaklee.shaklee_pws_name || shaklee.shaklee_sponsor_id)) {
            console.log('✅ SHAKLEE CONFIRMED via API data:', {
                pws_name: shaklee.shaklee_pws_name,
                sponsor_id: shaklee.shaklee_sponsor_id,
                user_id: shaklee.user_id
            });
            return true;
        }
        
        // PRIOrITY 3: Check passed prop from parent (SECOND MOST RELIABLE)
        if (isShakleeDistributor === true) {
            console.log('✅ SHAKLEE CONFIRMED via parent prop:', isShakleeDistributor);
            return true;
        }
        
        // PRIORITY 4: Check profile data string for Shaklee-specific fields

        if (actualProfile?.data && typeof actualProfile.data === 'string') {
            try {
                const profileData = JSON.parse(actualProfile.data);
                if (profileData?.shaklee_pws_name || profileData?.shaklee_sponsor_id) {
                    console.log('✅ SHAKLEE CONFIRMED via profile data:', {
                        pws_name: profileData.shaklee_pws_name,
                        sponsor_id: profileData.shaklee_sponsor_id
                    });
                    return true;
                }
            } catch (e) {
                console.log('❌ Profile data parsing error:', e);
            }
        }
        
        // LOWER PRIORITY: Company name checks (LESS RELIABLE due to conflicts)
        // Only use if no other detection methods worked
        console.log('⚠️ Using fallback company name detection (less reliable)');
        
        // Check profile company_name (but log the conflict for debugging)
        if (actualProfile?.company_name) {
            const companyName = actualProfile.company_name.toLowerCase();
            console.log('Company name found:', actualProfile.company_name);
            
            if (companyName === 'shaklee') {
                console.log('⚠️ SHAKLEE detected via company_name (potentially unreliable)');
                return true;
            } else if (companyName === 'melaleuca') {
                console.log('❌ Melaleuca detected - NOT Shaklee');
                return false;
            }
        }
        
        // Check site-level configuration as last resort
        if (site?.company_type?.toLowerCase() === 'shaklee' || 
            site?.distributor_type?.toLowerCase() === 'shaklee' ||
            site?.url?.toLowerCase().includes('shaklee')) {
            console.log('⚠️ SHAKLEE detected via site config (fallback method)');
            return true;
        }
        
        console.log('❌ NO SHAKLEE DETECTION - all methods failed');
        console.log('=== SHAKLEE DETECTION END ===');
        return false;
    };

    // Enhanced logging for debugging the Anne Thomas issue
    console.log('=== ANNE THOMAS DEBUG (Company Conflict Detection) ===');
    console.log('Profile company_name:', actualProfile?.company_name);
    console.log('Profile user name:', actualProfile?.user?.name);
    console.log('Profile user email:', actualProfile?.user?.email);
    console.log('Auth distributor_type:', auth?.distributor_type);
    console.log('Site company_type:', site?.company_type);
    console.log('Shaklee API data exists:', !!shaklee);
    console.log('Shaklee PWS name:', shaklee?.shaklee_pws_name);
    console.log('isShakleeDistributor prop:', isShakleeDistributor);

    // Additional validation - check for conflicting data
    if (actualProfile?.company_name) {
        const companyLower = actualProfile.company_name.toLowerCase();
        if ((companyLower === 'shaklee' || companyLower === 'melaleuca')) {
            console.log('🚨 POTENTIAL CONFLICT DETECTED 🚨');
            console.log('Company name:', actualProfile.company_name);
            console.log('Has Shaklee API data:', !!(shaklee?.shaklee_pws_name || shaklee?.shaklee_sponsor_id));
            console.log('Recommendation: Use API data over company name for reliability');
        }
    }
    console.log('=== END CONFLICT DEBUG ===');

    // Show Me+ology Assessment if Shaklee is detected (remove authentication requirement)
    const showMeologyAssessment = auth?.isAuthenticated && detectShaklee();

    // Console logging to debug Shaklee detection
    console.log('=== StripContactMe Debug Info ===');
    console.log('auth?.isAuthenticated:', auth?.isAuthenticated);
    console.log('isShakleeDistributor (prop):', isShakleeDistributor);
    console.log('shaklee data:', shaklee);
    console.log('actualProfile?.company_name:', actualProfile?.company_name);
    console.log('showMeologyAssessment (final):', showMeologyAssessment);
    console.log('site info:', {
        url: site?.url,
        accountId: site?.accountId,
        company_type: site?.company_type,
        distributor_type: site?.distributor_type
    });
    console.log('profile info:', {
        userId: actualProfile?.user?.id,
        company: actualProfile?.user?.company,
        distributor_type: actualProfile?.distributor_type,
        company_name: actualProfile?.company_name
    });
    console.log('auth info:', {
        distributorType: auth?.distributor_type,
        siteOwner: auth?.site_owner,
        isAuthenticated: auth?.isAuthenticated
    });
    console.log('=== End Debug Info ===');

    return (
        <>
            <div className="stripcontactme border px-md-5 px-3 py-3 mt-5">
                {/* Always show "Want a Personalized Nutrition Plan?" for everyone */}
                <p><strong>Want a Personalized Nutrition Plan?</strong></p>
                
                {/* Always show contact me for product support */}
                { actualProfile && actualProfile.phone ?
                    <p><Image width={30} src="/images/general/img-phone-icon01.png" className="mr-5"/><Link href={"tel:" + actualProfile.phone}><a className="text-reset h7"><u>Contact me for product support</u></a></Link></p>
                : null }
                
                {/* Show Me+ology Assessment ONLY for authenticated Shaklee distributors */}
                {showMeologyAssessment && (
                    <p><Image width={40} src="/images/general/img-meology-icon01.png" className="mr-5"/><Link href={shaklee ? 'https://meology.shaklee.com/?pwsName='+shaklee.shaklee_pws_name : ''}><a className="text-reset h7"><u>Take the Me+ology Assessment</u></a></Link></p>
                )}
            </div>
            <style jsx>
                {` 
                    .stripcontactme{
                        max-width:600px;
                    } 
                `}
            </style>
        </>
    )
}

export default StripContactMe